/**
 * The causes stage's sizing figure keys: the year-end shortfall, the part left unexplained and
 * each sized cause's share. The producer and its readers share them, so no reader guesses a key.
 */
export const SYNERGY_LOOP_CAUSE_KEYS = { shortfall: 'causes.share.shortfall',
  left: 'causes.share.left', share: (n: number) => `causes.share.${n}` } as const;
